import styled from 'styled-components';
import {
  Icon as IconSemantic,
} from 'semantic-ui-react';

const Container = styled.div`
  margin: 0 25px;
`;

const Header = styled.div`
  display: flex;
`;

const DayBoxHeader = styled.div`
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 45px;
  margin: 7px;
  color: ${({ theme }) => theme.color.textHeader};
  font-size: ${({ theme }) => theme.fontSize.textHeader};
  font-weight: 500;
`;

const DayBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 45px;
  margin: 7px;
  border: 2px solid ${({ theme }) => theme.color.button};
  color: ${({ theme, selectedDay }) => (!selectedDay ? theme.color.button : theme.color.buttonText)};
  font-size: ${({ theme }) => theme.fontSize.text};
  font-weight: 500;
  ${({ selectedDay, theme }) => selectedDay && `background: ${theme.color.button};`}

  :hover {
    cursor:pointer;
    color: ${({ theme }) => theme.color.buttonText};
    ${({ selectedDay, theme }) => !selectedDay && `background: ${theme.color.button};`}
  }
`;

const DayBoxNotShow = styled.div`
  display: flex;
  width: 100%;
  height: 45px;
  margin: 7px;
`;

const Icon = styled(IconSemantic)`
  &&& { 
    display: inline;
    margin: 0;
  }

  :hover {
    cursor: pointer;
  };
`;

const DayName = styled.div`

`;

const RowTime = styled.div`
  display: flex;
`;

const ContainerIcon = styled.div`
  position: absolute;
  ${({ left }) => (left ? 'left: 0;' : '')}
  ${({ right }) => (right ? 'right: 0;' : '')}
`;

const ContainerNoSlots = styled.div`
  display: flex;
  justify-content: center;
  padding: 100px;
  color: ${({ theme }) => theme.color.text};
  font-size: ${({ theme }) => theme.fontSize.textHeader};
`;

export {
  ContainerNoSlots,
  Container,
  ContainerIcon,
  DayBox,
  DayBoxHeader,
  DayName,
  Header,
  Icon,
  RowTime,
  DayBoxNotShow,
};
